<template>
  <div class="form-container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="房地产" name="estate"><EstateTable /></el-tab-pane>
      <el-tab-pane label="股权债权" name="equity"><EquityTable /></el-tab-pane>
      <el-tab-pane label="商业计划书" name="plan"><PlanTable /></el-tab-pane>
      <el-tab-pane label="行业研究咨询报告" name="industry"><IndustryTable /></el-tab-pane>
      <el-tab-pane label="房地产价值分析报告介绍" name="intro"><IntroTable /></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { ElTabs, ElTabPane } from "element-plus";
import EstateTable from "./tables/EstateTable.vue";
import EquityTable from "./tables/EquityTable.vue";
import PlanTable from "./tables/PlanTable.vue";
import IndustryTable from "./tables/IndustryTable.vue";
import IntroTable from "./tables/IntroTable.vue";
export default {
  name: "FormContainer",
  data() {
    return {
      activeName: "estate",
    };
  },
  components: { ElTabs, ElTabPane, EquityTable, EstateTable, PlanTable, IndustryTable, IntroTable },
};
</script>
<style lang="less">
.form-container {
  margin: 15px auto 15px auto;
  width: 95%;
  max-width: 968px;
  @media (max-width: 768px) {
    margin-top: 25px;
  }
}
</style>
